import React, { useEffect, useState } from 'react';
import { Layout, Menu, Typography, Button, Divider } from 'antd';
import {
  MedicineBoxOutlined,
  ShoppingCartOutlined,
  BarChartOutlined,
  SendOutlined,
  LogoutOutlined,
  UserOutlined,
  CheckCircleOutlined,
  InboxOutlined,
} from '@ant-design/icons';

const { Sider } = Layout;

interface BranchSidebarProps {
  open: boolean;
  onClose: () => void;
  onTabChange: (tab: string) => void;
  activeTab: string;
}

const BranchSidebar: React.FC<BranchSidebarProps> = ({ 
  open, 
  onClose, 
  onTabChange, 
  activeTab
}) => {
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const menuItems = [
    { key: 'medicines', icon: <MedicineBoxOutlined />, label: 'Medicine' },
    { key: 'checkout', icon: <ShoppingCartOutlined />, label: 'Checkout' },
    // { key: 'request-order', icon: <SendOutlined />, label: 'Request Order' },
    // { key: 'inventory-requests', icon: <InboxOutlined />, label: 'Inventory Requests' },
    // { key: 'branch-requests', icon: <CheckCircleOutlined />, label: 'Branch Requests' },
    { key: 'sales', icon: <BarChartOutlined />, label: 'Sales' },
    { key: 'profile', icon: <UserOutlined />, label: 'Profile' },
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    console.log('Menu clicked:', key, 'isMobile:', isMobile);
    onTabChange(key);
    // Only close sidebar on mobile devices after navigation
    if (isMobile) {
      console.log('Closing sidebar on mobile after navigation');
      onClose();
    } else {
      console.log('Keeping sidebar open on desktop');
    }
  };

  return (
    <>
      {/* Overlay for mobile - click outside to close */}
      {isMobile && open && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 998,
          }}
          onClick={onClose}
        />
      )}
      
      <Sider
        width={200}
        style={{
          position: 'fixed',
          left: 0,
          top: 64,
          bottom: 0,
          zIndex: 999,
          background: '#fff',
          boxShadow: '2px 0 8px rgba(0,0,0,0.15)',
          transform: open ? 'translateX(0)' : 'translateX(-200px)',
          transition: 'transform 0.3s ease',
        }}
      >
        <div style={{ padding: '16px' }}>
          <Typography.Title level={5} style={{ margin: 0, color: '#1890ff' }}>
            Branch Menu
          </Typography.Title>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[activeTab]}
          items={menuItems}
          onClick={handleMenuClick}
          style={{ border: 'none' }}
        />
        
        
        {/* Action Buttons at Bottom */}
        <div style={{ 
          position: 'absolute', 
          bottom: 0, 
          left: 0, 
          right: 0, 
          padding: '16px',
          background: '#fff',
          borderTop: '1px solid #f0f0f0'
        }}>
          <Divider style={{ margin: '0 0 16px 0' }} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Button
              icon={<LogoutOutlined />}
              onClick={() => {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/login';
              }}
              block
            >
              Logout
            </Button>
          </div>
        </div>
      </Sider>
    </>
  );
};

export default BranchSidebar;
